import React, { useEffect } from 'react';
import { ThemeProvider } from './components/ThemeContext';
import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Experience from './sections/Experience';
import Education from './sections/Education';
import Services from './sections/Services';
import Certifications from './sections/Certifications';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import Footer from './sections/Footer';
import Navbar from './components/Navbar';

export default function App() {
  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.12 }
    );

    revealElements.forEach(element => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <ThemeProvider>
      <div className="site-shell">
        <Navbar />
        <main>
          <Hero />
          <div className="reveal"><About /></div>
          <div className="reveal"><Skills /></div>
          <div className="reveal"><Experience /></div>
          <div className="reveal"><Education /></div>
          <div className="reveal"><Services /></div>
          <div className="reveal"><Certifications /></div>
          <div className="reveal"><Projects /></div>
          <div className="reveal"><Contact /></div>
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}